export const PARTICIPANT_STATUSES = {
  ACTIVE: 'active',
  BLOCKED: 'blocked',
  AWAITING: 'awaiting',
} as const;

export type ParticipantStatus = typeof PARTICIPANT_STATUSES[keyof typeof PARTICIPANT_STATUSES];
